import { adminHttpClient } from '../../../commons/adminHttpClient'
import OrderedPageFilter from '../../../commons/orderedPageFilter'

export type PerksReimbursementDueResponse = {
  availableAllowance: number
  expensesYTD: number
  firstName: string
  id: string
  lastName: string
  reimbursementsApprovedYTD: number
  reimbursementsDue: number
  offerSameAllowance: boolean
  expenses: ExpenseInfoResponse[]
}

type ExpenseInfoResponse = {
  id: string
  number: number
  approvedAmount: number
  amountToReimburse: number
}

export type PerksReimbursementDetailsResponse = {
  amountToReimburse: number
  employeeFullName: string
  employeeId: string
  offerSameAllowance: boolean
  availableAllowance: number
}
const getPerksReimbursementDue = (planPeriodId: string, filter: OrderedPageFilter): Promise<any> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/Reimbursements/GetPerksReimbursementDue/${planPeriodId}`, filter)
}

export default getPerksReimbursementDue
